import React from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { BonusTitle, CommanBgWrapper, HeadText, MainWrapper, StepsWrapper as RefillBonusStepsWrapper, TermsAndCondition, WelcomeBonusBody, WelcomeBonusTitle } from './WelcomeBonusFun';


type Props = {}

const RefillBonusf88 = (props: any) => {

    const { app: { brandId }, theme } = props;
    // const domainName = brandId === 31 || brandId === 32 ? 'Yolo247' : brandId === 33 ? 'IW247' : 'Betdaily' ;

    return (
        <>
            <MainWrapper>
                <CommanBgWrapper>
                    <HeadText>
                        <p>At FUN88, we believe in rewarding loyalty. That&apos;s why every deposit you make comes with an extra boost, <br/>giving you more chances to win&#33; With each new deposit, you can earn <strong>up to 4% bonus</strong> based on your membership tier&#58; <br/> <strong>Blue&#58; 1%, Silver&#58; 2%, Gold&#58; 3%, Platinum&#58; 4%.</strong></p>
                    </HeadText>
                </CommanBgWrapper>
                <CommanBgWrapper className='halfsize'>
                    <WelcomeBonusTitle>
                        <h1>What is a Refill Bonus?</h1>
                        <BonusTitle>
                            <p>Enjoy a bonus on every deposit according to your tier, with no roll-over requirements—it&apos;s credited instantly&#33; Here&apos;s how it works&#58;</p>
                        </BonusTitle>
                    </WelcomeBonusTitle>
                    <WelcomeBonusBody>
                        <StepsWrapper>
                                <p> <span>1&#58;</span> Log in to your FUN88 account</p>
                                <p> <span>2&#58;</span> For every deposit (after your first deposit),
                                    you&apos;ll receive your tier-specific bonus
                                    directly in your main wallet, instantly&#33;.</p>
                          
                        </StepsWrapper>
                    </WelcomeBonusBody>
                </CommanBgWrapper>
        
                <CommanBgWrapper  className='halfsize'>
                <TermsAndCondition>
                        <h1>Terms and conditions&#58;</h1>

                        <ol>
                            <li>Bonus amount will be credited to your Main Wallet after each successful re-deposit.</li>
                            <li>This promotion applies to every re-deposit, and all bonus amounts received must be used within 24 hours, after which they will expire.</li>
                            <li>Multiple accounts are not eligible for this promotion. All players are subject to duplicate checks, and FUN88 reserves the right to disqualify any player found engaging in collusion or foul play.</li>
                            <li>FUN88 reserves the right to amend, cancel, reclaim, or refuse any promotion at its discretion.</li>
                            <li>The bonus amount is non-withdrawable, but any winnings derived from the bonus can be withdrawn.</li>
                            <li>FUN88 General Terms & Conditions apply.</li>
                        </ol>
                    </TermsAndCondition>

                </CommanBgWrapper>
            </MainWrapper>
            {/* <FooterContent /> */}
        </>
    )
}

export default withAppContext(withTheme(RefillBonusf88));

//Styled Components

const StepsWrapper = styled(RefillBonusStepsWrapper)`
    width: 100%;
    align-items: flex-start;
    justify-content: center;

    p {
        text-align: left;
    }
`;

